import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import PageSeo from "@/components/PageSeo";

/**
 * Customer-side self-cancellation is disabled per restaurant policy.
 * This page catches any old cancel links floating around and redirects the
 * guest to a human channel.
 */
export default function CancelReservation() {
  return (
    <div data-testid="cancel-page" className="pt-32 pb-24 min-h-[70svh] flex items-center">
      <PageSeo
        title="Cancellations — The Barracks Bistro"
        description="Cancellations at The Barracks Bistro are handled directly by our team. Please call +91 82204 10761 or WhatsApp us."
        path="/r/cancel"
      />
      <div className="wrap max-w-xl">
        <div className="eyebrow">Cancellations</div>
        <h1 className="mt-2 text-4xl">Please give us a call</h1>
        <p className="mt-4 text-[hsl(var(--ink-soft))]">
          Cancellations and reschedules are handled by our reservations team so we can help you find
          a better slot instead of losing your table. It only takes a minute.
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <a
            data-testid="cancel-call"
            href="tel:+918220410761"
            className="btn-brass justify-center w-full sm:w-auto"
          >
            <Phone size={16} /> Call +91 82204 10761
          </a>
          <a
            data-testid="cancel-whatsapp"
            href="https://wa.me/918220410761"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 justify-center px-5 py-3 border border-[hsl(var(--brass))] text-[hsl(var(--brass-2))] hover:bg-[hsl(var(--brass))] hover:text-[hsl(var(--bg))] transition-colors w-full sm:w-auto"
          >
            <MessageCircle size={16} /> WhatsApp us
          </a>
          <Link
            to="/"
            className="mt-2 text-sm text-[hsl(var(--ink-soft))] hover:text-[hsl(var(--forest))]"
          >
            ← Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
